"use client";

import * as React from "react";
import { LinkContext, type LinkProps } from "./link-provider";

export function useLink(): React.ComponentType<LinkProps> | undefined {
  return React.useContext(LinkContext).Override;
}
